<template>
  <section class="ending">
    <div
      class="container aos-init aos-animate"
      data-aos="fade-down"
      data-aos-duration="2000"
    >
      <p>Get coverage with low-cost renters insurance today.</p>
      <router-link :to="{ name: 'quote' }">
        <button>Start a Quote</button>
      </router-link>
    </div>
  </section>
</template>
